import React, { Component } from 'react';
import {
  WithStyles, createStyles, Grid, Typography, IconButton, Tooltip, Button
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import { AUDIO_UPLOAD_MODES,AudioUrlImage } from '../../../../../constants/comman';

const styles = (theme: Theme) => createStyles({
  button: {
    margin: theme.spacing.unit,
  },
  progressBarContainer: {
    'border': 'solid 1px #DFDFDF',
    padding: '18px !important',
    'border-radius': '8px',
    margin: '30px 0',
    alignItems: 'center',
    pointerEvents: 'initial',
  },
  padRightNew: {
    paddingRight: '20px'
  },
  audioImgBox: {
    background: '#ECF5FE',
    border: '1px solid rgba(153, 153, 153, 0.3)',
    borderRadius: '4px',
    maxWidth:125,
    flexBasis:125,
    '& img': {
      margin: '0 auto',
      display: 'block',
    },
  },
  audioFileName: {
    paddingLeft: '15px',
    position: 'relative',
    textAlign: 'right',
    maxWidth: 'calc(100% - 165px)',
    flexBasis: 'calc(100% - 165px)',
  },
  fontSize12: {
    fontSize: '12px'
  },
  ProgressBarwithLabel: {
    fontSize: '12px',
    height: '8px',
    borderRadius: '17px',
    color: '#666666',
  },
  uploadTextLabel: {
    fontSize: '12px !important',
    fontWeight: 'normal',
    color: '#666666',
  },
  fileSizeSec: {
    display: 'block',
    position: 'absolute',
    bottom: '1px',
  },
  fileNameText: {
    textAlign: 'left',
    fontSize: '12px !important',
    fontWeight: 400,
    color: '#333333',
    display: 'flex',
    alignItems: 'center',
  },
  cancelBtnBox: {
    textAlign: 'right',
    maxWidth:40,
    flexBasis:40,
  },
  cancelBtn: {
    padding: '0 !important',
    marginTop: '-4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& span:last-child': {
      display: 'none',
    }
  },
  submitBtn: {
    fontSize: '16px',
    backgroundColor: '#1D7DEA',
    border: 'solid 1px #1D7DEA',
    color: '#fff',
    padding: '10px',
    minWidth: '128px',
    borderRadius: '4px',
    pointerEvents: 'initial',
    "&:disabled": {
      cursor: 'not-allowed',
      pointerEvents: 'initial',
    },
  },
  buttonCancel: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1D7DEA',
  },
  fileInitialName: {
    width: 'auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '12px !important',
    position: 'relative',
  },
  fileExtensionType: {
    width: '30px',
  },
});

interface AudioProgressBarProps extends WithStyles<typeof styles> {
  onDialogClose: Function;
  createAudioContent: Function;
  audioUploadProgressPercentage: any;
  audioURL: any;
  audioDetails: any;
  mode: string;
  deleteAudio: Function;
  removeFocus: Function;
}

interface AudioProgressBarState {
}
function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
  return (
    <div className='progressValue'>
      <div>
        <LinearProgress variant="buffer"   {...props} />
      </div>
      <div>
        <Typography variant="body2" color="textSecondary" className='progressValueText'>{`${Math.round(
          props.value,
        )}%`}</Typography>
      </div>
    </div>
  );
}

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

const convertAudioSize = (length: any) => {
  let typeIndex = 0, number = parseInt(length, 10) || 0;
  while (number >= 1024 && ++typeIndex) {
    number = number / 1024;
  }
  return (number.toFixed(number < 10 && typeIndex > 0 ? 1 : 0) + ' ' + units[typeIndex]);
}


class AudioProgressBar extends Component<AudioProgressBarProps, AudioProgressBarState> {
  constructor(props: AudioProgressBarProps) {
    super(props);
  }

  cancelUpload = () => {
    const { audioDetails, audioURL, audioUploadProgressPercentage } = this.props;
    this.props.removeFocus();
    if (audioUploadProgressPercentage >= 100 && audioURL.length) {
      this.props.deleteAudio(audioURL);
    } else {
      audioDetails.source.cancel();
    }
  }

  getInitialFileName = (file : string) => {
    const index = file.lastIndexOf('.');
    const fileName = file.slice(0, index);
    const fileExtension = file.slice(index);
    return {
      fileName,
      fileExtension,
    }
  }

  render() {
    const { classes, onDialogClose, createAudioContent, audioUploadProgressPercentage, audioURL = '', audioDetails, mode } = this.props;
    const totalAudioLength = convertAudioSize(parseInt(audioDetails.length));
    const uploadedAudioLength = convertAudioSize(parseInt(audioDetails.length, 10) * parseInt(audioUploadProgressPercentage, 10) / 100);
    const fileNameInitials = this.getInitialFileName(this.props.audioDetails.name);

    return (
      <>
        <div style={{ alignContent: 'center' }}>
          <Grid container className={classes.progressBarContainer}>
            <Grid item xs={3} className={classes.audioImgBox}>
              <img width="93px" height="62px" src={AudioUrlImage} />
            </Grid>
            <Grid item xs={8} className={classes.audioFileName}>
              <Typography className={classes.fileNameText}>
              <Tooltip title={fileNameInitials.fileName} placement="bottom-start">
                <span className={classes.fileInitialName}>
                  {fileNameInitials.fileName}
                </span>
                </Tooltip>
                <span className={classes.fileExtensionType}>
                  {fileNameInitials.fileExtension}
                </span>
              </Typography>
              <LinearProgressWithLabel
                value={audioUploadProgressPercentage}
                className={classes.ProgressBarwithLabel}
              />
              <div className={classes.fileSizeSec}>
                <div className={classes.uploadTextLabel}>
                  {`${uploadedAudioLength} of ${totalAudioLength}`}
                </div>
              </div>
            </Grid>
            <Grid item xs={1} className={classes.cancelBtnBox}>
              <IconButton
                className={classes.cancelBtn}
                aria-label="close"
                onClick={this.cancelUpload}
              >
                <img
                  alt="Cancel audio upload"
                  src="/assets/svg/learn/videoUploadCancel.svg"
                />
              </IconButton>
            </Grid>
          </Grid>
        </div>

        <Grid container>
          <Grid item sm />
          <Grid item>
            <Button
              disabled={
                audioUploadProgressPercentage < 100 || !audioURL.length
              }
              className={classes.submitBtn}
              variant="contained"
              color="primary"
              onClick={() => createAudioContent(audioURL, true)}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    audioUploadProgressPercentage: state.audioCreateContent.audioUploadProgressPercentage,
    audioURL: state.audioCreateContent.audioURL,
    audioDetails: state.audioCreateContent.audioDetails
  }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AudioProgressBar));